import { render, staticRenderFns } from "./shipments.vue?vue&type=template&id=1d8b2df4&scoped=true"
import script from "./shipments.vue?vue&type=script&lang=js"
export * from "./shipments.vue?vue&type=script&lang=js"
import style0 from "./shipments.vue?vue&type=style&index=0&id=1d8b2df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b2df4",
  null
  
)

export default component.exports